import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@ngx-translate/core';
import { AzavistaSharedModule } from '@azavista/components/shared';
function AzavistaSelectedItemsCountComponent_div_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.title);
  }
}
function AzavistaSelectedItemsCountComponent_div_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1, "SELECTED");
    i0.ɵɵelementEnd();
  }
}
function AzavistaSelectedItemsCountComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, AzavistaSelectedItemsCountComponent_div_0_span_1_Template, 2, 1, "span", 2)(2, AzavistaSelectedItemsCountComponent_div_0_span_2_Template, 2, 0, "span", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(": ", ctx_r0.count, "");
  }
}
let AzavistaSelectedItemsCountComponent = /*#__PURE__*/(() => {
  class AzavistaSelectedItemsCountComponent {
    constructor() {
      this.count = 0;
    }
    ngOnInit() {
      if (this.data) {
        this.count = this.data.allSelected ? this.data.totalCount : this.data.selectedCount;
      }
    }
    static {
      this.ɵfac = function AzavistaSelectedItemsCountComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaSelectedItemsCountComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaSelectedItemsCountComponent,
        selectors: [["azavista-selected-items-count"]],
        inputs: {
          data: "data"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["class", "aza-selected-items-count-container azavista-selected-items-count-component", 4, "ngIf"], [1, "aza-selected-items-count-container", "azavista-selected-items-count-component"], ["class", "aza-selected-items-count-title", 4, "ngIf"], ["class", "aza-selected-items-count-title", "translate", "", 4, "ngIf"], [1, "aza-selected-items-count-value"], [1, "aza-selected-items-count-title"], ["translate", "", 1, "aza-selected-items-count-title"]],
        template: function AzavistaSelectedItemsCountComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AzavistaSelectedItemsCountComponent_div_0_Template, 5, 3, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.data);
          }
        },
        dependencies: [i1.NgIf, i2.TranslateDirective],
        encapsulation: 2
      });
    }
  }
  return AzavistaSelectedItemsCountComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaSelectedItemsCountModule = /*#__PURE__*/(() => {
  class AzavistaSelectedItemsCountModule {
    static {
      this.ɵfac = function AzavistaSelectedItemsCountModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaSelectedItemsCountModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaSelectedItemsCountModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule]
      });
    }
  }
  return AzavistaSelectedItemsCountModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaSelectedItemsCountComponent, AzavistaSelectedItemsCountModule };
